import * as THREE from 'three';
import Action from '../classes/Action';
import Engine from '../classes/Engine';
import { CustomEventTypes } from '../globals';
import ProjectSaver from '../classes/ProjectSaver';
import SceneObjectUtils from '../classes/utilities/SceneObjectUtils';
import { IObjectSelection } from '../interfaces/Misc';

export interface IAddObjectData {
	object: THREE.Object3D;
	parent: THREE.Object3D;
	previousSelection: IObjectSelection;
	actionName: string;
}

export default class AddObjectAction extends Action
{
	static createAddObjectData(object: THREE.Object3D, position?: THREE.Vector3): IAddObjectData
	{
		const actionName = "Added " + object.name;

		if (position)
		{
			object.position.copy(position);
		}

		const previousSelection = Engine.getInstance().getPickingManager().getCurrentSelection();
		const parent = Engine.getInstance().getSelectionRoot();
		
		return {
			object: object,
			parent: parent,
			previousSelection: previousSelection,
			actionName: actionName
		}
	}
	constructor(object: THREE.Object3D, position?: THREE.Vector3)
	{
		const dataObject = AddObjectAction.createAddObjectData(object, position);
		super([dataObject.object, dataObject.parent], [dataObject.object, dataObject.previousSelection], dataObject.actionName);
	}

	static doFunction(object: THREE.Object3D, parent: THREE.Object3D): void
	{
		ProjectSaver.getInstance().markAsSaveRoot(object);
		Engine.getInstance().addObject(object, parent);
		Engine.getInstance().getPickingManager().clearSelection(false);
		Engine.getInstance().getPickingManager().selectObject(object);
		Engine.getInstance().getPickingManager().storeSelection();

		document.dispatchEvent(new CustomEvent(CustomEventTypes.objectSelectionChanged));
	}

	do(object: THREE.Object3D, parent: THREE.Object3D): void
	{
		AddObjectAction.doFunction(object, parent);
	}

	static undoFunction(object: THREE.Object3D, previousSelection: IObjectSelection): void
	{
		Engine.getInstance().getPickingManager().restoreSelection(previousSelection);
		Engine.getInstance().removeObject(object, true);
	}

	undo(object: THREE.Object3D, previousSelection: IObjectSelection): void
	{
		AddObjectAction.undoFunction(object, previousSelection);
	}

	dispose(): void
	{
		if (this.doParams)
		{
			const object = this.doParams?.[0];
			if ( object instanceof THREE.Object3D)
			{
				SceneObjectUtils.disposeObject(object, false);
			}
			else
			{
				console.warn("Parameter is not of type THREE.Object3D")
			}
		}
	}
}
